var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadCPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 354.07,
    height: 475.21,
    viewBox: "0 0 354.07 475.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #414042;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #939598;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #020202;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 351.57,
    x2: 351.57,
    y2: 475.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.16,7.4V160c-.37,4.48-2.47,19.71-21.36,33.29-18.28,13.14-40.8,16.48-47.86,17.34H12.51",
    transform: "translate(-12.51 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.16,482.6V330c-.37-4.48-2.47-19.71-21.36-33.29-18.28-13.14-40.8-16.48-47.86-17.34H12.51",
    transform: "translate(-12.51 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.16,275.28v-60.6a143.53,143.53,0,0,1-19.9,16.47A153.93,153.93,0,0,1,207.4,245a215.48,215.48,0,0,1,23.49,13.79A205.44,205.44,0,0,1,252.16,275.28Z",
    transform: "translate(-12.51 -7.4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.18,264.92H100.26a.71.71,0,0,1-.79-.62.72.72,0,0,1,.63-.79h16.08a.71.71,0,0,1,.17,1.41Z",
    transform: "translate(-12.51 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.82,264.71l-6.89,6.89a.71.71,0,0,1-1-1l6.39-6.39-6.38-6.34a.72.72,0,0,1,0-1,.74.74,0,0,1,.5-.2.68.68,0,0,1,.49.2l6.89,6.89A.7.7,0,0,1,116.82,264.71Z",
    transform: "translate(-12.51 -7.4)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.62,24.11V8.19A.71.71,0,0,1,276,8a.49.49,0,0,1,0,.17V24.11a.71.71,0,0,1-.62.79.72.72,0,0,1-.79-.62A.49.49,0,0,1,274.62,24.11Z",
    transform: "translate(-12.51 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.83,24.75l-6.89-6.89a.71.71,0,0,1,1-1l6.39,6.39,6.34-6.38a.7.7,0,0,1,1.2.5.7.7,0,0,1-.2.49l-6.89,6.89A.72.72,0,0,1,274.83,24.75Z",
    transform: "translate(-12.51 -7.4)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.87,465.89v15.92a.71.71,0,1,1-1.41.17V465.89a.72.72,0,0,1,.62-.79.7.7,0,0,1,.79.62A.49.49,0,0,1,341.87,465.89Z",
    transform: "translate(-12.51 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.66,465.25l6.89,6.89a.7.7,0,0,1,0,1,.72.72,0,0,1-1,0l-6.39-6.39-6.34,6.38a.72.72,0,0,1-1,0,.77.77,0,0,1-.2-.5.7.7,0,0,1,.2-.49l6.89-6.89A.72.72,0,0,1,341.66,465.25Z",
    transform: "translate(-12.51 -7.4)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.79,226.38h15.92a.69.69,0,0,1,.78.62.71.71,0,0,1-.62.79H100.79a.71.71,0,0,1-.17-1.41Z",
    transform: "translate(-12.51 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.15,226.59,107,219.7a.7.7,0,0,1,1,0,.72.72,0,0,1,0,1l-6.39,6.39,6.38,6.34a.72.72,0,0,1,0,1,.79.79,0,0,1-.5.2.68.68,0,0,1-.49-.2l-6.89-6.89A.7.7,0,0,1,100.15,226.59Z",
    transform: "translate(-12.51 -7.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadCPhoto);
export default __webpack_public_path__ + "static/media/road-C-photo.f049867aa4f6204420655bd015d7df0e.svg";
export { ForwardRef as ReactComponent };